const API_URL = (process.env.REACT_APP_API_URL || '').trim();

export { API_URL };
